import { atomWithReset as stateSegmentWithReset } from 'jotai/utils';

export interface ParamStatus {
  value: string;
  status: string;
}

export interface ParamStatusState {
  tone: ParamStatus;
  toneLevel: ParamStatus;
  exclusions: ParamStatus;
  inclusions: ParamStatus;
  contentStyle: ParamStatus;
  verbalIdentity: ParamStatus;
  context: ParamStatus;
}

export interface LastContentState {
  tone: string;
  toneLevel: string;
  exclusions: string;
  inclusions: string;
  contentStyle: string;
  verbalIdentity: string;
  context: string;
}

// State to store parameter statuses for each contentId
export type ParamsStatusSegment = Record<string, ParamStatusState>;

// State to track the last content for comparison
export const lastContentStateSegment = stateSegmentWithReset<LastContentState>({
  tone: '',
  toneLevel: '',
  exclusions: '',
  inclusions: '',
  contentStyle: '',
  verbalIdentity: '',
  context: '',
});

export const paramsStatusSegment = stateSegmentWithReset<ParamsStatusSegment>(
  {}
);
paramsStatusSegment.debugLabel = 'paramsStatusSegment';
lastContentStateSegment.debugLabel = 'lastContentStateSegment';
